import { keyBy } from 'es-toolkit/compat';

export interface ClassConfig {
  id?: string;
  dataItems?: string[];
  ignore?: boolean;
  color?: string;
  isPoint?: boolean;
  hollowShape?: boolean;
}

export interface ClassConfigYamlSchema {
  id?: number;
  data_items?: string[];
  ignore?: boolean;
  color?: string;
}

export interface ModelEvaluationArtifact {
  title?: string | null;
  fileType?: string;
  storageUrl?: string;
  artifactUrl?: string;
}

export interface MetaModel {
  description?: string;
  projectName?: string;
  end2end?: boolean;
  studyId?: string;
  modelId?: string;
  model_id?: string;
  tissueTypes?: string[];
  stainTypes?: string[];
  cellSegmentationGeometries?: string[];
  trainingType?: 'segmentation' | 'detection' | 'classification';
  modelType?: string;
  experimentJobId?: string;
  experiment_job_id?: string;
  checkpointNumber?: number;
  modelProvidedInferenceInputs?: unknown;
  deps?: {
    assignmentIds?: string[];
    classesConfig?: Record<string, ClassConfig | { [key: string]: any }>;
    membranalChannelNames?: string[];
    nuclearChannelNames?: string[];
    evaluationData?: ModelEvaluationArtifact;
    evaluationPlots?: Record<string, Record<string, unknown>>;
  };
}

export interface Model {
  id?: string;
  date?: string;
  url: string;
  meta: MetaModel;
  hashData?: string;
  hashDeps?: string;
}

export const getRegisteredModelId = (model?: Pick<Model, 'id' | 'meta'> | null) =>
  model?.meta?.modelId || model?.meta?.model_id || model?.id || '';

export const getModelExperimentJobId = (model?: Pick<Model, 'meta'> | null) =>
  model?.meta?.experimentJobId || model?.meta?.experiment_job_id || '';

export interface ModelResponse {
  items: Model[];
  totalPages: number;
  count: number;
  pageSize: number;
  page: number;
}

// According to algo/src/primitives/schemas/training.py
export const trainingTypeOptions = [
  {
    text: 'Segmentation',
    value: 'segmentation',
  },
  {
    text: 'Detection',
    value: 'detection',
  },
  {
    text: 'Classification',
    value: 'classification',
  },
];

export const trainingTypesByValue = keyBy(trainingTypeOptions, 'value');
